// // AboutEmployerModal.jsx
// import React from "react";
// import { MdClose, MdLocationPin, MdBusiness, MdVerified } from "react-icons/md";

// const AboutEmployerModal = ({
//   isOpen,
//   onClose,
//   companyName,
//   aboutUs,
//   location,
//   localGovernment,
//   city,
//   industry,
//   employerType,
//   size,
//   isVerified,
// }) => {
//   if (!isOpen) return null;

//   return (
//     <div
//       className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
//       onClick={onClose}
//     >
//       <div
//         className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto relative animate-in fade-in zoom-in-95 duration-200"
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* header */}
//         <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-5 rounded-t-2xl relative">
//           <button
//             onClick={onClose}
//             className="absolute top-4 right-4 text-white/80 hover:text-white transition"
//             aria-label="Close"
//           >
//             <MdClose size={22} />
//           </button>

//           <div className="flex items-center gap-3">
//             <div className="bg-white/20 p-2.5 rounded-xl">
//               <MdBusiness className="text-white" size={22} />
//             </div>
//             <div>
//               <h2 className="text-white font-bold text-lg capitalize leading-tight">
//                 {companyName}
//               </h2>
//               {isVerified && (
//                 <div className="flex items-center gap-1 text-white/90 text-xs mt-0.5">
//                   <MdVerified size={13} />
//                   <span>Verified Employer</span>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* body */}
//         <div className="p-6 space-y-5">
//           {/* quick facts */}
//           <div className="flex flex-wrap gap-2">
//             {industry && (
//               <span className="px-3 py-1 rounded-full bg-orange-50 text-orange-700 text-xs font-medium">
//                 {industry}
//               </span>
//             )}
//             {employerType && (
//               <span className="px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-xs font-medium">
//                 {employerType}
//               </span>
//             )}
//             {size && (
//               <span className="px-3 py-1 rounded-full bg-slate-100 text-slate-600 text-xs font-medium">
//                 {size} employees
//               </span>
//             )}
//           </div>

//           {(location || city || localGovernment) && (
//             <div className="flex items-start gap-2 text-sm text-gray-600">
//               <MdLocationPin className="text-orange-500 mt-0.5 flex-shrink-0" size={16} />
//               <span>
//                 {location}
//                 {localGovernment ? ` (LGA: ${localGovernment}` : ""}
//                 {city ? `, City: ${city})` : localGovernment ? ")" : ""}
//               </span>
//             </div>
//           )}

//           <div>
//             <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">
//               About the Company
//             </h3>
//             {aboutUs ? (
//               <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line">
//                 {aboutUs}
//               </p>
//             ) : (
//               <p className="text-gray-400 text-sm italic">
//                 This employer hasn't added a company description yet.
//               </p>
//             )}
//           </div>
//         </div>

//         {/* footer */}
//         <div className="px-6 pb-6">
//           <button
//             onClick={onClose}
//             className="w-full py-2.5 rounded-lg border border-gray-200 text-gray-600 text-sm font-medium hover:bg-gray-50 transition"
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutEmployerModal;






// pages/AboutEmployerPage.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import {
  MdLocationPin,
  MdBusiness,
  MdVerified,
  MdArrowBack,
  MdPeople,
  MdWork,
} from "react-icons/md";
import axios from "axios";
import Header from "./Header";

const AboutEmployerPage = () => {
  const { employerId } = useParams();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  const [employer, setEmployer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEmployer = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`${API_URL}jobrecruiter/employer/${employerId}`);
        setEmployer(res.data.employer || res.data);
      } catch (err) {
        console.log(err)
        setError(
          err.response?.data?.message || "Could not load company profile."
        );
      } finally {
        setLoading(false);
      }
    };
    if (employerId) fetchEmployer();
  }, [employerId, API_URL]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-orange-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-500 text-sm">Loading company profile…</p>
        </div>
      </div>
    );
  }

  if (error || !employer) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="text-center max-w-sm">
          <p className="text-gray-700 font-medium mb-2">
            {error || "Company not found."}
          </p>
          <button
            onClick={() => navigate(-1)}
            className="text-orange-500 hover:underline text-sm font-medium"
          >
            Go back
          </button>
        </div>
      </div>
    );
  }

  const {
    companyName,
    aboutUs,
    address,
    state,
    localGovernment,
    country,
    industry,
    employerType,
    size,
    isVerified,
    businessVerified,
    listedJobs,
    followerCount,
    createdAt,
  } = employer;

  return (
    <>
    <Header/>
  
  <div className="min-h-screen bg-gray-50 pb-16">
      {/* header banner */}
      <div className="bg-gradient-to-r from-orange-500 to-orange-600 pt-6 pb-20 px-4 sm:px-6 relative">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1.5 text-white/90 hover:text-white text-sm font-medium mb-6 transition"
        >
          <MdArrowBack size={18} />
          Back
        </button>
      </div>

      {/* content card, overlapping the banner */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 -mt-24">
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
          {/* company identity */}
          <div className="p-6 sm:p-8 border-b border-gray-100">
            <div className="flex items-start gap-4">
              <div className="bg-orange-50 p-3.5 rounded-2xl flex-shrink-0">
                <MdBusiness className="text-orange-600" size={28} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <h1 className="text-2xl font-bold text-gray-800 capitalize">
                    {companyName}
                  </h1>
                  {isVerified && (
                    <span className="flex items-center gap-1 bg-emerald-50 text-emerald-700 text-xs font-medium px-2.5 py-1 rounded-full">
                      <MdVerified size={13} />
                      Verified
                    </span>
                  )}
                  {businessVerified && (
                    <span className="bg-blue-50 text-blue-700 text-xs font-medium px-2.5 py-1 rounded-full">
                      Business Verified
                    </span>
                  )}
                </div>

                {(address || state || localGovernment || country) && (
                  <div className="flex items-start gap-1.5 text-gray-500 text-sm mt-2">
                    <MdLocationPin className="text-orange-500 mt-0.5 flex-shrink-0" size={15} />
                    <span>
                      {[address, localGovernment, state, country]
                        .filter(Boolean)
                        .join(", ")}
                    </span>
                  </div>
                )}
              </div>
            </div>

            {/* tags */}
            <div className="flex flex-wrap gap-2 mt-5">
              {industry && (
                <span className="px-3 py-1 rounded-full bg-orange-50 text-orange-700 text-xs font-medium">
                  {industry}
                </span>
              )}
              {employerType && (
                <span className="px-3 py-1 rounded-full bg-slate-100 text-slate-600 text-xs font-medium">
                  {employerType}
                </span>
              )}
              {size && (
                <span className="px-3 py-1 rounded-full bg-slate-100 text-slate-600 text-xs font-medium">
                  {size} employees
                </span>
              )}
            </div>
          </div>

          {/* stats row */}
          <div className="grid grid-cols-3 divide-x divide-gray-100  mt-15 border-b border-gray-100">
            <div className="flex flex-col items-center justify-center py-4">
              <div className="flex items-center gap-1.5 text-gray-800 font-bold text-lg">
                <MdWork className="text-orange-500" size={18} />
                {listedJobs?.length ?? 0}
              </div>
              <span className="text-xs text-gray-400 mt-0.5">Open Jobs</span>
            </div>
            <div className="flex flex-col items-center justify-center py-4">
              <div className="flex items-center gap-1.5 text-gray-800 font-bold text-lg">
                <MdPeople className="text-orange-500" size={18} />
                {followerCount ?? 0}
              </div>
              <span className="text-xs text-gray-400 mt-0.5">Followers</span>
            </div>
            {/* <div className="flex flex-col items-center justify-center py-4">
              <div className="text-gray-800 font-bold text-lg">
                {createdAt
                  ? new Date(createdAt).getFullYear()
                  : "—"}
              </div>
              <span className="text-xs text-gray-400 mt-0.5">Member Since</span>
            </div> */}
          </div>

          {/* about us */}
          <div className="p-6 sm:p-8">
            <h2 className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">
              About the Company
            </h2>
            {aboutUs ? (
              <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                {aboutUs}
              </p>
            ) : (
              <p className="text-gray-400 italic text-sm">
                This employer hasn't added a company description yet.
              </p>
            )}
          </div>

          {/* view open jobs */}
          {listedJobs?.length > 0 && (
            <div className="px-6 sm:px-8 pb-6 sm:pb-8">
              <Link
                to={`/jobs?employer=${employer._id}`}
                className="inline-flex items-center gap-1.5 text-orange-600 hover:text-orange-700 text-sm font-semibold hover:underline"
              >
                View all open positions →
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
    
    </>
  
  );
};

export default AboutEmployerPage;